import axios from 'axios'
import $store from '@state/store'
import { fullName } from '@src/utils/settings/tenant-user.util.js'
import i18n from '@src/i18n/index'
import { DOMAIN_TITLE } from '@src/constants/general-constants'
import { AuthService } from '@src/services/auth.service'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'

export default {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  removedOwnership(context, payload) {
    localStorage.setItem('auth.currentUser', JSON.stringify(payload))
  },
  logOut({ state, commit, rootState }, payload) {
    return AuthService.signOut(payload)
      .then(({ data }) => {
        commit('LOGOUT_CURRENT_USER', '')
      })
      .catch((error) => {
        throw error
      })
  },
  setupJwt(context, payload) {
    context.commit('SETUP_JWT', { context, payload })
  },

  // Logs in the current user.

  fetchOtpLoginData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      AuthService.fetchOtpLoginData(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
          reject(error)
        })
    })
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, payload) {
    return AuthService.login(payload)
      .then(({ data }) => {
        fullName(data?.user)
        const defaultCampus = data?.campuses[0] || ''
        const defaultClass = data?.campuses[0]?.classes[0] || ''
        const defaultSection = data?.campuses[0]?.classes[0]?.sections[0] || ''
        const currentRole = data?.user?.user_roles[0]?.role_id || null
        const instituteTitle = data?.institute_title || null
        const setting = data?.setting || []
        const generalSettings = data?.generalSettings || []
        const instituteCounts = data?.institute_counts || null
        const guardianAssociatedStudents = data?.students || null
        const subDomain = data?.sub_domain || null
        const disableFeatures = data?.disabled_features?.map((item) => item.feature_name) || '[]'
        // Set First campus and Section

        if (currentRole !== TENANT_ROLES.SUPER_ADMIN || !setting?.multiple_campuses_allowed)
          commit('layout/SET_SELECTED_CAMPUSE', defaultCampus, { root: true })

        if (
          ![
            TENANT_ROLES.SUPER_ADMIN,
            TENANT_ROLES.CAMPUS_ADMIN,
            TENANT_ROLES.GUARDIAN,
            TENANT_ROLES.STAFF,
          ].includes(currentRole)
        ) {
          commit('layout/SET_CURRENT_SELECTED_CLASS_SCOPE', defaultClass, { root: true })
          commit('layout/SET_CURRENT_SELECTED_SECTION_SCOPE', defaultSection, { root: true })
        }

        if (currentRole === TENANT_ROLES.GUARDIAN) {
          commit('layout/SET_ASSOCIATED_STUDENT', guardianAssociatedStudents, { root: true })

          if (!!guardianAssociatedStudents.length) {
            commit('layout/SET_GUARDIAN_AND_STUDENT_PROFILES', true, { root: true })
            $store.commit('student/SET_ACTIVE_STUDENT', true)
            commit('layout/SET_CURRENT_SELECTED_CLASS_SCOPE', defaultClass, { root: true })
            commit('layout/SET_CURRENT_SELECTED_SECTION_SCOPE', defaultSection, { root: true })
          }
        }

        // Set current Role
        commit('layout/SET_SELECTED_ROLE', currentRole, { root: true })

        // Set Institute Counts
        commit('layout/SET_INSTITUE_COUNTS', instituteCounts, { root: true })

        // Set Institute Counts
        commit('SET_DOMAIN', subDomain)

        // Set Institute Settings
        commit('layout/SET_INSTITUE_SETTINGS', data.setting, { root: true })
        commit('layout/SET_GENERAL_SETTINGS', generalSettings, { root: true })

        // Call Action To Set JWT Token
        dispatch('setupJwt', data.jwt)

        // Set Current User Data
        commit('SET_CURRENT_USER', data)

        // Set Disable feature list
        commit('layout/SET_DISABLED_FEATURE_LIST', disableFeatures, { root: true })

        /* GENERAL SETTINGS INITIALIZE */
        dispatch(
          'settings/initGeneralSetting',
          {
            logo: data?.setting?.image,
            favicon: data?.setting?.favicon,
            institute_name: data?.setting?.title,
            site_title: data.setting?.site_title?.site_title || DOMAIN_TITLE,
            reset: true,
          },
          { root: true },
        )

        /* SITE SETTINGS INITIALIZE */
        dispatch('settings/loadSiteSettings', data.setting, { root: true })

        saveToLocalStorage({
          setting: setting,
          instituteTitle: instituteTitle,
        })
      })
      .catch((error) => {
        commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
        throw error
      })
      .finally(() => commit('layout/DONE_LOADING', {}, { root: true }))
  },

  fetchUserDomains({ commit }, payload) {
    return new Promise((resolve, reject) => {
      AuthService.fetchUserDomains(payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
        })
    })
  },

  resendRegistrationEmail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      AuthService.resendRegistrationEmail(payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
        })
    })
  },

  getUserRegistrationStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      AuthService.getUserRegistrationStatus(payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentUser ? state.currentUser.token : ''
}

function saveToLocalStorage(data) {
  let instituteCounts = JSON.parse(localStorage.getItem('institutesCounts'))
  if (
    (instituteCounts && !instituteCounts.campuses_count) ||
    (instituteCounts && !instituteCounts.classes_count) ||
    (instituteCounts && !instituteCounts.sectiones_count)
  )
    localStorage.setItem('instituteTitle', JSON.stringify(data.instituteTitle))

  localStorage.setItem('setting', JSON.stringify(data.setting))
}
